'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @public
 */
var Subtitle = _styledComponents2.default.h2.withConfig({
  displayName: 'subtitle__Subtitle'
})(['margin:0;font-size:var(--subtitle-font-size,2em);font-family:var( --subtitle-font-fammily,var(--title-font-family,var(--font-family,var(--default-font-family))) );text-align:center;']);

/**
 * @private
 */
Subtitle.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node

  /**
   * @private
   */
};Subtitle.displayName = 'Subtitle';

exports.default = Subtitle;